(window.webpackJsonp=window.webpackJsonp||[]).push([[8],{
/***/"7BTU":
/***/function(t,e,n){"use strict";
/* unused harmony export flush */
/* harmony export (binding) */n.d(e,"b",(function(){return d})),
/* harmony export (binding) */n.d(e,"a",(function(){return c}));
/* harmony import */n("SRZj");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Module for scheduling flushable pre-render and post-render tasks.
 *
 * @summary Module for scheduling flushable pre-render and post-render tasks.
 */let o=!1,r=[],i=[];function s(){o=!0,// before next render
requestAnimationFrame((function(){o=!1,l(r),// after the render
setTimeout((function(){!function(t){for(let e=0,n=t.length;e<n;e++)a(t.shift())}(i)}))}))}function l(t){for(;t.length;)a(t.shift())}function a(t){const e=t[0],n=t[1],o=t[2];try{n.apply(e,o)}catch(t){setTimeout(()=>{throw t})}}
/**
 * Flushes all `beforeNextRender` tasks, followed by all `afterNextRender`
 * tasks.
 *
 * @return {void}
 */
/**
 * Enqueues a callback which will be run before the next render, at
 * `requestAnimationFrame` timing.
 *
 * This method is useful for enqueuing work that requires DOM measurement,
 * since measurement may not be reliable in custom element callbacks before
 * the first render, as well as for batching measurement tasks in general.
 *
 * Tasks in this queue may be flushed by calling `flush()`.
 *
 * @param {*} context Context object the callback function will be bound to
 * @param {function(...*):void} callback Callback function
 * @param {!Array=} args An array of arguments to call the callback function with
 * @return {void}
 */
function d(t,e,n){o||s(),r.push([t,e,n])}
/**
 * Enqueues a callback which will be run after the next render, equivalent
 * to one task (`setTimeout`) after the next `requestAnimationFrame`.
 *
 * This method is useful for tuning the first-render performance of an
 * element or application by deferring non-critical work until after the
 * first paint.  Typical non-render-critical work may include adding UI
 * event listeners and aria attributes.
 *
 * @param {*} context Context object the callback function will be bound to
 * @param {function(...*):void} callback Callback function
 * @param {!Array=} args An array of arguments to call the callback function with
 * @return {void}
 */function c(t,e,n){o||s(),i.push([t,e,n])}
/***/},
/***/"9RTV":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return l}));
/* harmony import */n("SRZj");
/* harmony import */var o=n("MDMB");
/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
const r=window.ShadyDOM,i=window.ShadyCSS;
/**
 * Return true if node scope is correct.
 *
 * @param {!Element} node Node to check scope
 * @param {!Node} scope Scope reference
 * @return {boolean} True if node is in scope
 */
function s(t,e){return Object(o.a)(t).getRootNode()===e}
/**
 * Ensure that elements in a ShadowDOM container are scoped correctly.
 * This function is only needed when ShadyDOM is used and unpatched DOM APIs are used in third party code.
 * This can happen in noPatch mode or when specialized APIs like ranges or tables are used to mutate DOM.
 *
 * @param  {!Element} container Container element to scope
 * @param  {boolean=} shouldObserve if true, start a mutation observer for added nodes to the container
 * @return {?MutationObserver} Returns a new MutationObserver on `container` if `shouldObserve` is true.
 */function l(t,e=!1){
// If using native ShadowDOM, abort
if(!r||!i)return null;// ShadyCSS handles DOM mutations when ShadyDOM does not handle scoping itself
if(!r.handlesDynamicScoping)return null;const n=i.ScopingShim;// if ScopingShim is not available, abort
if(!n)return null;// capture correct scope for container
const l=n.scopeForNode(t),a=Object(o.a)(t).getRootNode(),d=t=>{if(!s(t,a))return;// NOTE: native qSA does not honor scoped DOM, but it is faster, and the same behavior as Polymer v1
const e=Array.from(r.nativeMethods.querySelectorAll.call(t,"*"));e.push(t);for(let t=0;t<e.length;t++){const o=e[t];if(!s(o,a))continue;const r=n.currentScopeForNode(o);r!==l&&(""!==r&&n.unscopeNode(o,r),n.scopeNode(o,l))}};if(// scope everything in container
d(t),e){const e=new MutationObserver(t=>{for(let e=0;e<t.length;e++){const n=t[e];for(let t=0;t<n.addedNodes.length;t++){const e=n.addedNodes[t];e.nodeType===Node.ELEMENT_NODE&&d(e)}}});return e.observe(t,{childList:!0,subtree:!0}),e}return null}
/***/},
/***/E3QQ:
/***/function(t,e,n){"use strict";
/* unused harmony export stylesFromModules */
/* unused harmony export stylesFromModule */
/* harmony export (binding) */n.d(e,"c",(function(){return d})),
/* harmony export (binding) */n.d(e,"b",(function(){return c})),
/* harmony export (binding) */n.d(e,"a",(function(){return p}));
/* unused harmony export cssFromModule */
/* unused harmony export cssFromTemplate */
/* unused harmony export cssFromModuleImports */
/* harmony import */var o=n("O5q1"),r=n("sBZK");
/* harmony import */
/**
 * @param {string} moduleId .
 * @return {?DomModule} .
 */
function i(t){
/** @type {?DomModule} */
return o.a.import(t)}function s(t){
// NOTE: polyfill affordance.
// under the HTMLImports polyfill, there will be no 'body',
// but the import pseudo-doc can be used directly.
let e=t.body?t.body:t;const n=Object(r.b)(e.textContent,t.baseURI),o=document.createElement("style");return o.textContent=n,o}
/** @typedef {{assetpath: string}} */ // eslint-disable-line no-unused-vars
/**
 * Returns a list of <style> elements in a space-separated list of `dom-module`s.
 *
 * @function
 * @param {string} moduleIds List of dom-module id's within which to
 * search for css.
 * @return {!Array<!HTMLStyleElement>} Array of contained <style> elements
 */
function l(t){const e=t.trim().split(/\s+/),n=[];for(let t=0;t<e.length;t++)n.push(...a(e[t]));return n}
/**
 * Returns a list of <style> elements in a given `dom-module`.
 * Styles in a `dom-module` can come either from `<style>`s within the
 * first `<template>`, or else from one or more
 * `<link rel="import" type="css">` links outside the template.
 *
 * @param {string} moduleId dom-module id to gather styles from
 * @return {!Array<!HTMLStyleElement>} Array of contained styles.
 */function a(t){const e=i(t);if(!e)return console.warn("Could not find style data in module named",t),[];if(void 0===e._styles){const t=[];// module imports: <link rel="import" type="css">
t.push(...u(e));// include css from the first template in the module
const n=
/** @type {?HTMLTemplateElement} */
e.querySelector("template");n&&t.push(...d(n,
/** @type {templateWithAssetPath} */
e.assetpath)),e._styles=t}return e._styles}
/**
 * Returns the `<style>` elements within a given template.
 *
 * @param {!HTMLTemplateElement} template Template to gather styles from
 * @param {string=} baseURI baseURI for style content
 * @return {!Array<!HTMLStyleElement>} Array of styles
 */function d(t,e){if(!t._styles){const n=[],o=t.content.querySelectorAll("style");// if element is a template, get content from its .content
for(let t=0;t<o.length;t++){let i=o[t],s=i.getAttribute("include");// support style sharing by allowing styles to "include"
// other dom-modules that contain styling
s&&n.push(...l(s).filter((function(t,e,n){return n.indexOf(t)===e}))),e&&(i.textContent=Object(r.b)(i.textContent,
/** @type {string} */
e)),n.push(i)}t._styles=n}return t._styles}
/**
 * Returns a list of <style> elements  from stylesheets loaded via `<link rel="import" type="css">` links within the specified `dom-module`.
 *
 * @param {string} moduleId Id of `dom-module` to gather CSS from
 * @return {!Array<!HTMLStyleElement>} Array of contained styles.
 */function c(t){let e=i(t);return e?u(e):[]}
/**
 * @param {!HTMLElement} module dom-module element that could contain `<link rel="import" type="css">` styles
 * @return {!Array<!HTMLStyleElement>} Array of contained styles
 */function u(t){const e=[],n=t.querySelectorAll("link[rel=import][type~=css]");for(let t=0;t<n.length;t++){let o=n[t];if(o.import){const t=o.import,n=o.hasAttribute("shady-unscoped");if(n&&!t._unscopedStyle){const e=s(t);e.setAttribute("shady-unscoped",""),t._unscopedStyle=e}else t._style||(t._style=s(t));e.push(n?t._unscopedStyle:t._style)}}return e}
/**
 *
 * Returns CSS text of styles in a space-separated list of `dom-module`s.
 * Note: This method is deprecated, use `stylesFromModules` instead.
 *
 * @deprecated
 * @param {string} moduleIds List of dom-module id's within which to
 * search for css.
 * @return {string} Concatenated CSS content from specified `dom-module`s
 */function p(t){let e=t.trim().split(/\s+/),n="";for(let t=0;t<e.length;t++)n+=_(e[t]);return n}
/**
 * Returns CSS text of styles in a given `dom-module`.  CSS in a `dom-module`
 * can come either from `<style>`s within the first `<template>`, or else
 * from one or more `<link rel="import" type="css">` links outside the
 * template.
 *
 * Any `<styles>` processed are removed from their original location.
 * Note: This method is deprecated, use `styleFromModule` instead.
 *
 * @deprecated
 * @param {string} moduleId dom-module id to gather styles from
 * @return {string} Concatenated CSS content from specified `dom-module`
 */function _(t){let e=i(t);if(e&&void 0===e._cssText){
// module imports: <link rel="import" type="css">
let t=f(e),n=
/** @type {?HTMLTemplateElement} */
e.querySelector("template");// include css from the first template in the module
n&&(t+=
/**
 * Returns CSS text of `<styles>` within a given template.
 *
 * Any `<styles>` processed are removed from their original location.
 * Note: This method is deprecated, use `styleFromTemplate` instead.
 *
 * @deprecated
 * @param {!HTMLTemplateElement} template Template to gather styles from
 * @param {string} baseURI Base URI to resolve the URL against
 * @return {string} Concatenated CSS content from specified template
 */
function(t,e){let n="";const o=d(t,e);// if element is a template, get content from its .content
for(let t=0;t<o.length;t++){let e=o[t];e.parentNode&&e.parentNode.removeChild(e),n+=e.textContent}return n}
/**
 * Returns CSS text from stylesheets loaded via `<link rel="import" type="css">`
 * links within the specified `dom-module`.
 *
 * Note: This method is deprecated, use `stylesFromModuleImports` instead.
 *
 * @deprecated
 *
 * @param {string} moduleId Id of `dom-module` to gather CSS from
 * @return {string} Concatenated CSS content from links in specified `dom-module`
 */(n,
/** @type {templateWithAssetPath} */
e.assetpath)),e._cssText=t||null}return e||console.warn("Could not find style data in module named",t),e&&e._cssText||""}
/**
 * @deprecated
 * @param {!HTMLElement} module dom-module element that could contain `<link rel="import" type="css">` styles
 * @return {string} Concatenated CSS content from links in the dom-module
 */
function f(t){let e="",n=u(t);for(let t=0;t<n.length;t++)e+=n[t].textContent;return e}
/***/},
/***/F3iu:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i}));
/* harmony import */var o=n("Wbgf"),r=n("o5Wi");
/* harmony import */
/* harmony reexport (safe) */n.d(e,"b",(function(){return r.a}));
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Base class that provides the core API for Polymer's meta-programming
 * features including template stamping, data-binding, attribute deserialization,
 * and property change observation.
 *
 * @customElement
 * @polymer
 * @constructor
 * @implements {Polymer_ElementMixin}
 * @extends HTMLElement
 * @appliesMixin ElementMixin
 * @summary Custom element base class that provides the core API for Polymer's
 *   key meta-programming features including template stamping, data-binding,
 *   attribute deserialization, and property change observation
 */
const i=Object(o.a)(HTMLElement);
/***/},
/***/"H/aU":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"s",(function(){return r})),
/* unused harmony export useNativeCSSProperties */
/* unused harmony export useNativeCustomElements */
/* harmony export (binding) */n.d(e,"o",(function(){return i})),
/* harmony export (binding) */n.d(e,"k",(function(){return s})),
/* unused harmony export setRootPath */
/* harmony export (binding) */n.d(e,"l",(function(){return l})),
/* unused harmony export setSanitizeDOMValue */
/* unused harmony export getSanitizeDOMValue */
/* harmony export (binding) */n.d(e,"i",(function(){return a})),
/* harmony export (binding) */n.d(e,"m",(function(){return d})),
/* harmony export (binding) */n.d(e,"n",(function(){return c})),
/* unused harmony export setStrictTemplatePolicy */
/* harmony export (binding) */n.d(e,"a",(function(){return u})),
/* unused harmony export setAllowTemplateFromDomModule */
/* harmony export (binding) */n.d(e,"e",(function(){return p})),
/* unused harmony export setLegacyOptimizations */
/* harmony export (binding) */n.d(e,"g",(function(){return _})),
/* unused harmony export setLegacyWarnings */
/* harmony export (binding) */n.d(e,"q",(function(){return f})),
/* unused harmony export setSyncInitialRender */
/* harmony export (binding) */n.d(e,"f",(function(){return h})),
/* unused harmony export setLegacyUndefined */
/* harmony export (binding) */n.d(e,"h",(function(){return y})),
/* unused harmony export setOrderedComputed */
/* harmony export (binding) */n.d(e,"b",(function(){return m})),
/* unused harmony export setCancelSyntheticClickEvents */
/* harmony export (binding) */n.d(e,"j",(function(){return w})),
/* unused harmony export setRemoveNestedTemplates */
/* harmony export (binding) */n.d(e,"c",(function(){return P})),
/* unused harmony export setFastDomIf */
/* harmony export (binding) */n.d(e,"p",(function(){return b})),
/* unused harmony export setSuppressTemplateNotifications */
/* harmony export (binding) */n.d(e,"d",(function(){return O})),
/* unused harmony export setLegacyNoObservedAttributes */
/* harmony export (binding) */n.d(e,"r",(function(){return S}));
/* unused harmony export setUseAdoptedStyleSheetsWithBuiltCSS */
/* harmony import */n("SRZj");
/* harmony import */var o=n("sBZK");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
const r=!window.ShadyDOM||!window.ShadyDOM.inUse,i=(Boolean(!window.ShadyCSS||window.ShadyCSS.nativeCss),window.customElements.polyfillWrapFlushCallback,r&&"adoptedStyleSheets"in Document.prototype&&"replaceSync"in CSSStyleSheet.prototype&&// Since spec may change, feature detect exact API we need
(()=>{try{const t=new CSSStyleSheet;t.replaceSync("");const e=document.createElement("div");return e.attachShadow({mode:"open"}),e.shadowRoot.adoptedStyleSheets=[t],e.shadowRoot.adoptedStyleSheets[0]===t}catch(t){return!1}})());
/**
 * Globally settable property that is automatically assigned to
 * `ElementMixin` instances, useful for binding in templates to
 * make URL's relative to an application's root.  Defaults to the main
 * document URL, but can be overridden by users.  It may be useful to set
 * `rootPath` to provide a stable application mount path when
 * using client side routing.
 */
let s=window.Polymer&&window.Polymer.rootPath||Object(o.a)(document.baseURI||window.location.href);
/**
 * Sets the global rootPath property used by `ElementMixin` and
 * available via `rootPath`.
 *
 * @param {string} path The new root path
 * @return {void}
 */
/**
 * A global callback used to sanitize any value before inserting it into the DOM.
 * The callback signature is:
 *
 *  function sanitizeDOMValue(value, name, type, node) { ... }
 *
 * Where:
 *
 * `value` is the value to sanitize.
 * `name` is the name of an attribute or property (for example, href).
 * `type` indicates where the value is being inserted: one of property, attribute, or text.
 * `node` is the node where the value is being inserted.
 *
 * @type {(function(*,string,string,?Node):*)|undefined}
 */
let l=window.Polymer&&window.Polymer.sanitizeDOMValue||void 0;
/**
 * Sets the global sanitizeDOMValue available via this module's exported
 * `sanitizeDOMValue` variable.
 *
 * @param {(function(*,string,string,?Node):*)|undefined} newSanitizeDOMValue the global sanitizeDOMValue callback
 * @return {void}
 */
/**
 * Globally settable property to make Polymer Gestures use passive TouchEvent listeners when recognizing gestures.
 * When set to `true`, gestures made from touch will not be able to prevent scrolling, allowing for smoother
 * scrolling performance.
 * Defaults to `false` for backwards compatibility.
 */
let a=window.Polymer&&window.Polymer.setPassiveTouchGestures||!1;
/**
 * Sets `passiveTouchGestures` globally for all elements using Polymer Gestures.
 *
 * @param {boolean} usePassive enable or disable passive touch gestures globally
 * @return {void}
 */const d=function(t){a=t};
/**
 * Setting to ensure Polymer template evaluation only occurs based on tempates
 * defined in trusted script.  When true, `<dom-module>` re-registration is
 * disallowed, `<dom-bind>` is disabled, and `<dom-if>`/`<dom-repeat>`
 * templates will only evaluate in the context of a trusted element template.
 */let c=window.Polymer&&window.Polymer.strictTemplatePolicy||!1;
/**
 * Sets `strictTemplatePolicy` globally for all elements
 *
 * @param {boolean} useStrictPolicy enable or disable strict template policy
 *   globally
 * @return {void}
 */
/**
 * Setting to enable dom-module lookup from Polymer.Element.  By default,
 * templates must be defined in script using the `static get template()`
 * getter and the `html` tag function.  To enable legacy loading of templates
 * via dom-module, set this flag to true.
 */
let u=window.Polymer&&window.Polymer.allowTemplateFromDomModule||!1;
/**
 * Sets `lookupTemplateFromDomModule` globally for all elements
 *
 * @param {boolean} allowDomModule enable or disable template lookup
 *   globally
 * @return {void}
 */
/**
 * Setting to skip processing style includes and re-writing urls in css styles.
 * Normally "included" styles are pulled into the element and all urls in styles
 * are re-written to be relative to the containing script url.
 * If no includes or relative urls are used in styles, these steps can be
 * skipped as an optimization.
 */
let p=window.Polymer&&window.Polymer.legacyOptimizations||!1;
/**
 * Sets `legacyOptimizations` globally for all elements to enable optimizations
 * when only legacy based elements are used.
 *
 * @param {boolean} useLegacyOptimizations enable or disable legacy optimizations
 * includes and url rewriting
 * @return {void}
 */
/**
 * Setting to add warnings useful when migrating from Polymer 1.x to 2.x.
 */
let _=window.Polymer&&window.Polymer.legacyWarnings||!1;
/**
 * Sets `legacyWarnings` globally for all elements to migration warnings.
 *
 * @param {boolean} useLegacyWarnings enable or disable warnings
 * @return {void}
 */
/**
 * Setting to perform initial rendering synchronously when running under ShadyDOM.
 * This matches the behavior of Polymer 1.
 */
let f=window.Polymer&&window.Polymer.syncInitialRender||!1;
/**
 * Sets `syncInitialRender` globally for all elements to enable synchronous
 * initial rendering.
 *
 * @param {boolean} useSyncInitialRender enable or disable synchronous initial
 * rendering globally.
 * @return {void}
 */
/**
 * Setting to retain the legacy Polymer 1 behavior for multi-property
 * observers around undefined values. Observers and computed property methods
 * are not called until no argument is undefined.
 */
let h=window.Polymer&&window.Polymer.legacyUndefined||!1;
/**
 * Sets `legacyUndefined` globally for all elements to enable legacy
 * multi-property behavior for undefined values.
 *
 * @param {boolean} useLegacyUndefined enable or disable legacy
 * multi-property behavior for undefined.
 * @return {void}
 */
/**
 * Setting to ensure computed properties are computed in order to ensure
 * re-computation never occurs in a given turn.
 */
let y=window.Polymer&&window.Polymer.orderedComputed||!1;
/**
 * Sets `orderedComputed` globally for all elements to enable ordered computed
 * property computation.
 *
 * @param {boolean} useOrderedComputed enable or disable ordered computed effects
 * @return {void}
 */
/**
 * Setting to cancel synthetic click events fired by older mobile browsers. Modern browsers
 * no longer fire synthetic click events, and the cancellation behavior can interfere
 * when programmatically clicking on elements.
 */
let m=!0;
/**
 * Sets `setCancelSyntheticEvents` globally for all elements to cancel synthetic click events.
 *
 * @param {boolean} useCancelSyntheticClickEvents enable or disable cancelling synthetic
 * events
 * @return {void}
 */
/**
 * Setting to remove nested templates inside `dom-if` and `dom-repeat` as
 * part of element template parsing.  This is a performance optimization that
 * eliminates most of the tax of needing two elements due to the loss of
 * type-extended templates as a result of the V1 specification changes.
 */
let w=window.Polymer&&window.Polymer.removeNestedTemplates||!1;
/**
 * Sets `removeNestedTemplates` globally, to eliminate nested templates
 * inside `dom-if` and `dom-repeat` as part of template parsing.
 *
 * @param {boolean} useRemoveNestedTemplates enable or disable removing nested
 *   templates during parsing
 * @return {void}
 */
/**
 * Setting to place `dom-if` elements in a performance-optimized mode that takes
 * advantage of lighter-weight host runtime template stamping to eliminate the
 * need for an intermediate Templatizer `TemplateInstance` to mange the nodes
 * stamped by `dom-if`.  Under this setting, any Templatizer-provided API's
 * such as `modelForElement` will not be available for nodes stamped by
 * `dom-if`.
 */
let P=window.Polymer&&window.Polymer.fastDomIf||!1;
/**
 * Sets `fastDomIf` globally, to put `dom-if` in a performance-optimized mode.
 *
 * @param {boolean} useFastDomIf enable or disable `dom-if` fast-mode
 * @return {void}
 */
/**
 * Setting to disable `dom-change` and `rendered-item-count` events from
 * `dom-if` and `dom-repeat`. Users can opt back into `dom-change` events by
 * setting the `notify-dom-change` attribute (`notifyDomChange: true` property)
 * to `dom-if`/`don-repeat` instances.
 */
let b=window.Polymer&&window.Polymer.suppressTemplateNotifications||!1;
/**
 * Sets `suppressTemplateNotifications` globally, to disable `dom-change` and
 * `rendered-item-count` events from `dom-if` and `dom-repeat`.
 *
 * @param {boolean} suppress enable or disable `suppressTemplateNotifications`
 * @return {void}
 */
/**
 * Setting to disable use of dynamic attributes. This is an optimization
 * to avoid setting `observedAttributes`. Instead attributes are read
 * once at create time and set/removeAttribute are patched.
 */
let O=window.Polymer&&window.Polymer.legacyNoObservedAttributes||!1;
/**
 * Sets `legacyNoObservedAttributes` globally, to disable `observedAttributes`.
 *
 * @param {boolean} noObservedAttributes enable or disable `legacyNoObservedAttributes`
 * @return {void}
 */
/**
 * Setting to enable use of `adoptedStyleSheets` for sharing style sheets
 * between component instances' shadow roots, if the app uses built Shady CSS
 * styles.
 */
let S=window.Polymer&&window.Polymer.useAdoptedStyleSheetsWithBuiltCSS||!1;
/**
 * Sets `useAdoptedStyleSheetsWithBuiltCSS` globally.
 *
 * @param {boolean} value enable or disable `useAdoptedStyleSheetsWithBuiltCSS`
 * @return {void}
 */},
/***/LDKE:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return p})),
/* harmony export (binding) */n.d(e,"c",(function(){return b})),
/* harmony export (binding) */n.d(e,"a",(function(){return O}));
/* unused harmony export TemplateInstanceBase */
/* harmony import */n("SRZj");
/* harmony import */var o=n("5HyR"),r=n("wmdp"),i=n("H/aU"),s=n("MDMB");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Module for preparing and stamping instances of templates that utilize
 * Polymer's data-binding and declarative event listener features.
 *
 * Example:
 *
 *     // Get a template from somewhere, e.g. light DOM
 *     let template = this.querySelector('template');
 *     // Prepare the template
 *     let TemplateClass = Templatize.templatize(template);
 *     // Instance the template with an initial data model
 *     let instance = new TemplateClass({myProp: 'initial'});
 *     // Insert the instance's DOM somewhere, e.g. element's shadow DOM
 *     this.shadowRoot.appendChild(instance.root);
 *     // Changing a property on the instance will propagate to bindings
 *     // in the template
 *     instance.myProp = 'new value';
 *
 * The `options` dictionary passed to `templatize` allows for customizing
 * features of the generated template class, including how outer-scope host
 * properties should be forwarded into template instances, how any instance
 * properties added into the template's scope should be notified out to
 * the host, and whether the instance should be decorated as a "parent model"
 * of any event handlers.
 *
 *     // Customize property forwarding and event model decoration
 *     let TemplateClass = Templatize.templatize(template, this, {
 *       parentModel: true,
 *       forwardHostProp(property, value) {...},
 *       instanceProps: {...},
 *       notifyInstanceProp(instance, property, value) {...},
 *     });
 *
 * @summary Module for preparing and stamping instances of templates
 *   utilizing Polymer templating features.
 */
// Base class for HTMLTemplateElement extension that has property effects
// machinery for propagating host properties to children. This is an ES5
// class only because Babel (incorrectly) requires super() in the class
// constructor even though no `this` is used and it returns an instance.
let l=null;
/**
 * @constructor
 * @extends {HTMLTemplateElement}
 * @private
 */function a(){return l}a.prototype=Object.create(HTMLTemplateElement.prototype,{constructor:{value:a,writable:!0}});
/**
 * @constructor
 * @implements {Polymer_PropertyEffects}
 * @extends {HTMLTemplateElementExtension}
 * @private
 */
const d=Object(o.a)(a),c=Object(r.a)(d);
/**
 * @constructor
 * @implements {Polymer_MutableData}
 * @extends {DataTemplate}
 * @private
 */
/**
 * Base class for TemplateInstance.
 * @constructor
 * @extends {HTMLElement}
 * @implements {Polymer_PropertyEffects}
 * @private
 */
const u=Object(o.a)(class{});function p(t,e){for(let n=0;n<e.length;n++){let o=e[n];// Ignore non-changes
if(Boolean(t)!=Boolean(o.__hideTemplateChildren__))
// clear and restore text
if(o.nodeType===Node.TEXT_NODE)t?(o.__polymerTextContent__=o.textContent,o.textContent=""):o.textContent=o.__polymerTextContent__;// remove and replace slot
else if("slot"===o.localName)if(t)o.__polymerReplaced__=document.createComment("hidden-slot"),Object(s.a)(Object(s.a)(o).parentNode).replaceChild(o.__polymerReplaced__,o);else{const t=o.__polymerReplaced__;t&&Object(s.a)(Object(s.a)(t).parentNode).replaceChild(o,t)}else o.style&&(t?(o.__polymerDisplay__=o.style.display,o.style.display="none"):o.style.display=o.__polymerDisplay__);o.__hideTemplateChildren__=t,o._showHideChildren&&o._showHideChildren(t)}}
/**
 * @polymer
 * @customElement
 * @appliesMixin PropertyEffects
 * @unrestricted
 */class _ extends u{constructor(t){super(),this._configureProperties(t),
/** @type {!StampedTemplate} */
this.root=this._stampTemplate(this.__dataHost);// Save list of stamped children
let e=[];
/** @suppress {invalidCasts} */this.children=
/** @type {!NodeList} */
e;// Polymer 1.x did not use `Polymer.dom` here so not bothering.
for(let t=this.root.firstChild;t;t=t.nextSibling)e.push(t),t.__templatizeInstance=this;this.__templatizeOwner&&this.__templatizeOwner.__hideTemplateChildren__&&this._showHideChildren(!0);// Flush props only when props are passed if instance props exist
// or when there isn't instance props.
let n=this.__templatizeOptions;(t&&n.instanceProps||!n.instanceProps)&&this._enableProperties()}
/**
   * Configure the given `props` by calling `_setPendingProperty`. Also
   * sets any properties stored in `__hostProps`.
   * @private
   * @param {Object} props Object of property name-value pairs to set.
   * @return {void}
   */_configureProperties(t){if(this.__templatizeOptions.forwardHostProp)for(let t in this.__hostProps)this._setPendingProperty(t,this.__dataHost["_host_"+t]);// Any instance props passed in the constructor will overwrite host props;
// normally this would be a user error but we don't specifically filter them
for(let e in t)this._setPendingProperty(e,t[e])}
/**
   * Forwards a host property to this instance.  This method should be
   * called on instances from the `options.forwardHostProp` callback
   * to propagate changes of host properties to each instance.
   *
   * Note this method enqueues the change, which are flushed as a batch.
   *
   * @param {string} prop Property or path name
   * @param {*} value Value of the property to forward
   * @return {void}
   */forwardHostProp(t,e){this._setPendingPropertyOrPath(t,e,!1,!0)&&this.__dataHost._enqueueClient(this)}
/**
   * Override point for adding custom or simulated event handling.
   *
   * @override
   * @param {!Node} node Node to add event listener to
   * @param {string} eventName Name of event
   * @param {function(!Event):void} handler Listener function to add
   * @return {void}
   */_addEventListenerToNode(t,e,n){if(this._methodHost&&this.__templatizeOptions.parentModel)
// If this instance should be considered a parent model, decorate
// events this template instance as `model`
this._methodHost._addEventListenerToNode(t,e,t=>{t.model=this,n(t)});else{
// Otherwise delegate to the template's host (which could be)
// another template instance
let o=this.__dataHost.__dataHost;o&&o._addEventListenerToNode(t,e,n)}}
/**
   * Shows or hides the template instance top level child elements. For
   * text nodes, `textContent` is removed while "hidden" and replaced when
   * "shown."
   * @param {boolean} hide Set to true to hide the children;
   * set to false to show them.
   * @return {void}
   * @protected
   */_showHideChildren(t){p(t,this.children)}
/**
   * Overrides default property-effects implementation to intercept
   * textContent bindings while children are "hidden" and cache in
   * private storage for later retrieval.
   *
   * @override
   * @param {!Node} node The node to set a property on
   * @param {string} prop The property to set
   * @param {*} value The value to set
   * @return {void}
   * @protected
   */_setUnmanagedPropertyToNode(t,e,n){t.__hideTemplateChildren__&&t.nodeType==Node.TEXT_NODE&&"textContent"==e?t.__polymerTextContent__=n:super._setUnmanagedPropertyToNode(t,e,n)}
/**
   * Find the parent model of this template instance.  The parent model
   * is either another templatize instance that had option `parentModel: true`,
   * or else the host element.
   *
   * @return {!Polymer_PropertyEffects} The parent model of this instance
   */get parentModel(){let t=this.__parentModel;if(!t){let e;t=this;do{
// A template instance's `__dataHost` is a <template>
// `model.__dataHost.__dataHost` is the template's host
t=t.__dataHost.__dataHost}while((e=t.__templatizeOptions)&&!e.parentModel);this.__parentModel=t}return t}
/**
   * Stub of HTMLElement's `dispatchEvent`, so that effects that may
   * dispatch events safely no-op.
   *
   * @param {Event} event Event to dispatch
   * @return {boolean} Always true.
   * @override
   */dispatchEvent(t){
// eslint-disable-line no-unused-vars
return!0}}
/** @type {!DataTemplate} */_.prototype.__dataHost,
/** @type {!TemplatizeOptions} */
_.prototype.__templatizeOptions,
/** @type {!Polymer_PropertyEffects} */
_.prototype._methodHost,
/** @type {!Object} */
_.prototype.__templatizeOwner,
/** @type {!Object} */
_.prototype.__hostProps;
/**
 * @constructor
 * @extends {TemplateInstanceBase}
 * @implements {Polymer_MutableData}
 * @private
 */
const f=Object(r.a)(// This cast shouldn't be neccessary, but Closure doesn't understand that
// TemplateInstanceBase is a constructor function.
/** @type {function(new:TemplateInstanceBase)} */
_);function h(t){
// Technically this should be the owner of the outermost template.
// In shadow dom, this is always getRootNode().host, but we can
// approximate this via cooperation with our dataHost always setting
// `_methodHost` as long as there were bindings (or id's) on this
// instance causing it to get a dataHost.
let e=t.__dataHost;return e&&e._methodHost||e}
/* eslint-disable valid-jsdoc */
/**
 * @suppress {missingProperties} class.prototype is not defined for some reason
 */function y(t,e,n){
/**
   * @constructor
   * @extends {TemplateInstanceBase}
   */
let o=n.mutableData?f:_;// Affordance for global mixins onto TemplatizeInstance
b.mixin&&(o=b.mixin(o))
/**
   * Anonymous class created by the templatize
   * @constructor
   * @private
   */;let r=class extends o{};
/** @override */return r.prototype.__templatizeOptions=n,r.prototype._bindTemplate(t),function(t,e,n,o){let r=n.hostProps||{};for(let e in o.instanceProps){delete r[e];let n=o.notifyInstanceProp;n&&t.prototype._addPropertyEffect(e,t.prototype.PROPERTY_EFFECT_TYPES.NOTIFY,{fn:P(e,n)})}if(o.forwardHostProp&&e.__dataHost)for(let e in r)
// As we're iterating hostProps in this function, note whether
// there were any, for an optimization in addPropagateEffects
n.hasHostProps||(n.hasHostProps=!0),t.prototype._addPropertyEffect(e,t.prototype.PROPERTY_EFFECT_TYPES.NOTIFY,{fn:function(t,e,n){t.__dataHost._setPendingPropertyOrPath("_host_"+e,n[e],!0,!0)}})}(r,t,e,n),r}
/**
 * Adds propagate effects from the template to the template instance for
 * properties that the host binds to the template using the `_host_` prefix.
 *
 * @suppress {missingProperties} class.prototype is not defined for some reason
 */function m(t,e,n,o){let r=n.forwardHostProp;if(r&&e.hasHostProps){
// Under the `removeNestedTemplates` optimization, a custom element like
// `dom-if` or `dom-repeat` can itself be treated as the "template"; this
// flag is used to switch between upgrading a `<template>` to be a property
// effects client vs. adding the effects directly to the custom element
const u="template"==t.localName;// Provide data API and property effects on memoized template class
let p=e.templatizeTemplateClass;if(!p){if(u){
/**
         * @constructor
         * @extends {DataTemplate}
         */
let t=n.mutableData?c:d;// NOTE: due to https://github.com/google/closure-compiler/issues/2928,
// combining the next two lines into one assignment causes a spurious
// type error.
/** @private */class o extends t{}p=e.templatizeTemplateClass=o}else{
/**
         * @constructor
         * @extends {PolymerElement}
         */
const n=t.constructor;// Create a cached subclass of the base custom element class onto which
// to put the template-specific propagate effects
// NOTE: due to https://github.com/google/closure-compiler/issues/2928,
// combining the next two lines into one assignment causes a spurious
// type error.
/** @private */class o extends n{}p=e.templatizeTemplateClass=o}// Add template - >instances effects
// and host <- template effects
let s=e.hostProps;for(let t in s)p.prototype._addPropertyEffect("_host_"+t,p.prototype.PROPERTY_EFFECT_TYPES.PROPAGATE,{fn:w(t,r)}),p.prototype._createNotifyingProperty("_host_"+t);i.g&&o&&function(t,e,n){const o=n.constructor._properties,{propertyEffects:r}=t,{instanceProps:i}=e;for(let t in r)
// Ensure properties with template effects are declared on the outermost
// host (`methodHost`), unless they are instance props or static functions
if(!(o[t]||i&&i[t])){const e=r[t];for(let n=0;n<e.length;n++){const{part:o}=e[n].info;if(!o.signature||!o.signature.static){console.warn(`Property '${t}' used in template but not declared in 'properties'; attribute will not be observed.`);break}}}}
/**
 * Returns the template "model" associated with a given element, which
 * serves as the binding scope for the template instance the element is
 * contained in. A template model is an instance of
 * `TemplateInstanceBase`, and should be used to manipulate data
 * associated with this template instance.
 *
 * Example:
 *
 *   let model = modelForElement(el);
 *   if (model.index < 10) {
 *     model.set('item.checked', true);
 *   }
 *
 * @param {HTMLElement} template The model will be returned for
 *   elements stamped from this template (accepts either an HTMLTemplateElement)
 *   or a `<dom-if>`/`<dom-repeat>` element when using `removeNestedTemplates`
 *   optimization.
 * @param {Node=} node Node for which to return a template model.
 * @return {TemplateInstanceBase} Template instance representing the
 *   binding scope for the element
 */(e,n,o)}// Mix any pre-bound data into __data; no need to flush this to
// instances since they pull from the template at instance-time
if(t.__dataProto&&
// Note, generally `__dataProto` could be chained, but it's guaranteed
// to not be since this is a vanilla template we just added effects to
Object.assign(t.__data,t.__dataProto),u)a=p,l=s=t,Object.setPrototypeOf(s,a.prototype),new a,l=null,// Clear any pending data for performance
t.__dataTemp={},t.__dataPending=null,t.__dataOld=null,t._enableProperties();else{
// Swizzle the cached subclass prototype onto the custom element
Object.setPrototypeOf(t,p.prototype);// Check for any pre-bound instance host properties, and do the
// instance property delete/assign dance for those (directly into data;
// not need to go through accessor since they are pulled at instance time)
const n=e.hostProps;for(let e in n)if(e="_host_"+e,e in t){const n=t[e];delete t[e],t.__data[e]=n}}}// Applies a DataTemplate subclass to a <template> instance
var s,a}
/* eslint-enable valid-jsdoc */function w(t,e){return function(t,n,o){e.call(t.__templatizeOwner,n.substring("_host_".length),o[n])}}function P(t,e){return function(t,n,o){e.call(t.__templatizeOwner,t,n,o[n])}}
/**
 * Returns an anonymous `PropertyEffects` class bound to the
 * `<template>` provided.  Instancing the class will result in the
 * template being stamped into a document fragment stored as the instance's
 * `root` property, after which it can be appended to the DOM.
 *
 * Templates may utilize all Polymer data-binding features as well as
 * declarative event listeners.  Event listeners and inline computing
 * functions in the template will be called on the host of the template.
 *
 * The constructor returned takes a single argument dictionary of initial
 * property values to propagate into template bindings.  Additionally
 * host properties can be forwarded in, and instance properties can be
 * notified out by providing optional callbacks in the `options` dictionary.
 *
 * Valid configuration in `options` are as follows:
 *
 * - `forwardHostProp(property, value)`: Called when a property referenced
 *   in the template changed on the template's host. As this library does
 *   not retain references to templates instanced by the user, it is the
 *   templatize owner's responsibility to forward host property changes into
 *   user-stamped instances.  The `instance.forwardHostProp(property, value)`
 *    method on the generated class should be called to forward host
 *   properties into the template to prevent unnecessary property-changed
 *   notifications. Any properties referenced in the template that are not
 *   defined in `instanceProps` will be notified up to the template's host
 *   automatically.
 * - `instanceProps`: Dictionary of property names that will be added
 *   to the instance by the templatize owner.  These properties shadow any
 *   host properties, and changes within the template to these properties
 *   will result in `notifyInstanceProp` being called.
 * - `mutableData`: When `true`, the generated class will skip strict
 *   dirty-checking for objects and arrays (always consider them to be
 *   "dirty").
 * - `notifyInstanceProp(instance, property, value)`: Called when
 *   an instance property changes.  Users may choose to call `notifyPath`
 *   on e.g. the owner to notify the change.
 * - `parentModel`: When `true`, events handled by declarative event listeners
 *   (`on-event="handler"`) will be decorated with a `model` property pointing
 *   to the template instance that stamped it.  It will also be returned
 *   from `instance.parentModel` in cases where template instance nesting
 *   causes an inner model to shadow an outer model.
 *
 * All callbacks are called bound to the `owner`. Any context
 * needed for the callbacks (such as references to `instances` stamped)
 * should be stored on the `owner` such that they can be retrieved via
 * `this`.
 *
 * When `options.forwardHostProp` is declared as an option, any properties
 * referenced in the template will be automatically forwarded from the host of
 * the `<template>` to instances, with the exception of any properties listed in
 * the `options.instanceProps` object.  `instanceProps` are assumed to be
 * managed by the owner of the instances, either passed into the constructor
 * or set after the fact.  Note, any properties passed into the constructor will
 * always be set to the instance (regardless of whether they would normally
 * be forwarded from the host).
 *
 * Note that `templatize()` can be run only once for a given `<template>`.
 * Further calls will result in an error. Also, there is a special
 * behavior if the template was duplicated through a mechanism such as
 * `<dom-repeat>` or `<test-fixture>`. In this case, all calls to
 * `templatize()` return the same class for all duplicates of a template.
 * The class returned from `templatize()` is generated only once using
 * the `options` from the first call. This means that any `options`
 * provided to subsequent calls will be ignored. Therefore, it is very
 * important not to close over any variables inside the callbacks. Also,
 * arrow functions must be avoided because they bind the outer `this`.
 * Inside the callbacks, any contextual information can be accessed
 * through `this`, which points to the `owner`.
 *
 * @param {!HTMLTemplateElement} template Template to templatize
 * @param {Polymer_PropertyEffects=} owner Owner of the template instances;
 *   any optional callbacks will be bound to this owner.
 * @param {Object=} options Options dictionary (see summary for details)
 * @return {function(new:TemplateInstanceBase, Object=)} Generated class bound
 *   to the template provided
 * @suppress {invalidCasts}
 */
function b(t,e,n){
// Under strictTemplatePolicy, the templatized element must be owned
// by a (trusted) Polymer element, indicated by existence of _methodHost;
// e.g. for dom-if & dom-repeat in main document, _methodHost is null
if(i.n&&!h(t))throw new Error("strictTemplatePolicy: template owner not trusted");if(n=
/** @type {!TemplatizeOptions} */
n||{},t.__templatizeOwner)throw new Error("A <template> can only be templatized once");t.__templatizeOwner=e;let o=(e?e.constructor:_)._parseTemplate(t),r=o.templatizeInstanceClass;// Get memoized base class for the prototypical template, which
// includes property effects for binding template & forwarding
/**
   * @constructor
   * @extends {TemplateInstanceBase}
   */r||(r=y(t,o,n),o.templatizeInstanceClass=r);const s=h(t);// Host property forwarding must be installed onto template instance
m(t,o,n,s);// Subclass base class and add reference for this specific template
/** @private */
let l=class extends r{};
/** @override */ //eslint-disable-line no-self-assign
return l.prototype._methodHost=s,
/** @override */
l.prototype.__dataHost=
/** @type {!DataTemplate} */
t,
/** @override */
l.prototype.__templatizeOwner=
/** @type {!Object} */
e,
/** @override */
l.prototype.__hostProps=o.hostProps,l=
/** @type {function(new:TemplateInstanceBase)} */
l,l}function O(t,e){let n;for(;e;)
// An element with a __templatizeInstance marks the top boundary
// of a scope; walk up until we find one, and then ensure that
// its __dataHost matches `this`, meaning this dom-repeat stamped it
if(n=e.__dataHost?e:e.__templatizeInstance){
// Found an element stamped by another template; keep walking up
// from its __dataHost
if(n.__dataHost==t)return n;e=n.__dataHost}else
// Still in a template scope, keep going up until
// a __templatizeInstance is found
e=Object(s.a)(e).parentNode;return null}
/***/},
/***/MDMB:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return o}));
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/* eslint-disable valid-jsdoc */
/**
 * Node wrapper to ensure ShadowDOM safe operation regardless of polyfill
 * presence or mode. Note that with the introduction of `ShadyDOM.noPatch`,
 * a node wrapper must be used to access ShadowDOM API.
 * This is similar to using `Polymer.dom` but relies exclusively
 * on the presence of the ShadyDOM polyfill rather than requiring the loading
 * of legacy (Polymer.dom) API.
 * @type {function(Node):Node}
 */
const o=window.ShadyDOM&&window.ShadyDOM.noPatch&&window.ShadyDOM.wrap?window.ShadyDOM.wrap:window.ShadyDOM?t=>ShadyDOM.patch(t):t=>t
/***/},
/***/Qieo:
/***/function(t,e,n){"use strict";
/* unused harmony export instanceCount */
/* harmony export (binding) */n.d(e,"a",(function(){return o})),
/* unused harmony export registrations */
/* harmony export (binding) */n.d(e,"b",(function(){return i}));function o(){0}
/**
 * Array of Polymer element classes that have been finalized.
 * @type {!Array<!PolymerElementConstructor>}
 */const r=[];
/**
 * @param {!PolymerElementConstructor} prototype Element prototype to log
 * @private
 */
/**
 * Registers a class prototype for telemetry purposes.
 * @param {!PolymerElementConstructor} prototype Element prototype to register
 * @protected
 */
function i(t){r.push(t)}
/**
 * Logs all elements registered with an `is` to the console.
 * @public
 */},
/***/TDwC:
/***/function(t,e,n){"use strict";
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/function o(){document.body.removeAttribute("unresolved")}"interactive"===document.readyState||"complete"===document.readyState?o():window.addEventListener("DOMContentLoaded",o)
/***/},
/***/pYlh:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return r}));
/* harmony import */var o=n("EVa9");
/* harmony import */n("qEMp"),n("HtFd"),n("HLTo"),n("iFZw"),n("PUnk"),n("5EBg"),n("GgZ1"),n("aUK7"),n("o5Wi");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/* template elements */
/* custom-style */
/* bc behaviors */
/* import html-tag to export html */
// bc
const r=Object(o.a)(HTMLElement).prototype;
/***/},
/***/sBZK:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"c",(function(){return l})),
/* harmony export (binding) */n.d(e,"b",(function(){return a})),
/* harmony export (binding) */n.d(e,"a",(function(){return d}));
/* harmony import */n("SRZj");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/let o,r,i=/(url\()([^)]*)(\))/g,s=/(^\/[^\/])|(^#)|(^[\w-\d]*:)/;
/**
 * Resolves the given URL against the provided `baseUri'.
 *
 * Note that this function performs no resolution for URLs that start
 * with `/` (absolute URLs) or `#` (hash identifiers).  For general purpose
 * URL resolution, use `window.URL`.
 *
 * @param {string} url Input URL to resolve
 * @param {?string=} baseURI Base URI to resolve the URL against
 * @return {string} resolved URL
 */
function l(t,e){if(t&&s.test(t))return t;if("//"===t)return t;// Lazy feature detection.
if(void 0===o){o=!1;try{const t=new URL("b","http://a");t.pathname="c%20d",o="http://a/c%20d"===t.href}catch(t){// silently fail
}}if(e||(e=document.baseURI||window.location.href),o)try{return new URL(t,e).href}catch(e){
// Bad url or baseURI structure. Do not attempt to resolve.
return t}// Fallback to creating an anchor into a disconnected document.
return r||(r=document.implementation.createHTMLDocument("temp"),r.base=r.createElement("base"),r.head.appendChild(r.base),r.anchor=r.createElement("a"),r.body.appendChild(r.anchor)),r.base.href=e,r.anchor.href=t,r.anchor.href||t}
/**
 * Resolves any relative URL's in the given CSS text against the provided
 * `ownerDocument`'s `baseURI`.
 *
 * @param {string} cssText CSS text to process
 * @param {string} baseURI Base URI to resolve the URL against
 * @return {string} Processed CSS text with resolved URL's
 */function a(t,e){return t.replace(i,(function(t,n,o,r){return n+"'"+l(o.replace(/["']/g,""),e)+"'"+r}))}
/**
 * Returns a path from a given `url`. The path includes the trailing
 * `/` from the url.
 *
 * @param {string} url Input URL to transform
 * @return {string} resolved path
 */function d(t){return t.substring(0,t.lastIndexOf("/")+1)}
/***/}}]);